/* 🤖 this file was generated by svg-to-ts */
export const matIconMarkunreadMailbox: {
  name: 'markunread-mailbox';
  data: string;
} = {
  name: 'markunread-mailbox',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"/></svg>`
};
